import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Scale, CheckCircle } from 'lucide-react';

const TeamSection = ({ t }) => {
  const teamMembers = [
    {
      name: 'Advocate Imran Pathan',
      designation: 'High Court Advocate',
      designation_hi: 'उच्च न्यायालय अधिवक्ता',
      court: 'High Court Bar Association, Allahabad',
      court_hi: 'उच्च न्यायालय बार एसोसिएशन, इलाहाबाद',
      registration: ['Bar Council Enrollment: UP03008', 'COP No. 286647'],
      registration_hi: ['बार काउंसिल नामांकन: UP03008', 'COP No. 286647'],
      image: 'https://customer-assets.emergentagent.com/job_legal-portfolio-12/artifacts/w3bh928m_unnamed%20%281%29.jpg',
      specialization: 'Criminal Law, Civil Litigation, Family Law, Property Disputes',
      specialization_hi: 'आपराधिक कानून, सिविल मुकदमेबाजी, पारिवारिक कानून, संपत्ति विवाद'
    },
    {
      name: 'Advocate Faizan Pathan',
      designation: 'Criminal Law Specialist',
      designation_hi: 'आपराधिक कानून विशेषज्ञ',
      court: 'District Bar Association, Aligarh',
      court_hi: 'जिला बार एसोसिएशन, अलीगढ़',
      image: 'https://customer-assets.emergentagent.com/job_highcourt-law/artifacts/7ir2gqih_InShot_20250121_083834968%20%281%29.jpg',
      specialization: 'Criminal Litigation, FIR Defense, Trial Proceedings',
      specialization_hi: 'आपराधिक मुकदमेबाजी, एफआईआर बचाव, मुकदमे की कार्यवाही'
    },
    {
      name: 'Advocate Alfiya Khan',
      designation: 'Civil Law Specialist',
      designation_hi: 'सिविल कानून विशेषज्ञ',
      court: 'Delhi Bar Association, Tis Hazari Court',
      court_hi: 'दिल्ली बार एसोसिएशन, तीस हजारी कोर्ट',
      image: 'https://customer-assets.emergentagent.com/job_legal-portfolio-12/artifacts/tfvmyzwe_IMG-20260110-WA0089.jpg',
      specialization: 'Civil Cases, Property Disputes, Contract Law',
      specialization_hi: 'सिविल मामले, संपत्ति विवाद, अनुबंध कानून'
    },
    {
      name: 'Advocate Harsh Kumar',
      designation: 'Criminal Law Specialist',
      designation_hi: 'आपराधिक कानून विशेषज्ञ',
      court: 'High Court, Delhi',
      court_hi: 'उच्च न्यायालय, दिल्ली',
      image: 'https://customer-assets.emergentagent.com/job_highcourt-law/artifacts/n5qlpv0u_IMG-20260203-WA0085.jpg',
      specialization: 'Criminal Cases, Bail Matters, Trial Defense',
      specialization_hi: 'आपराधिक मामले, जमानत मामले, मुकदमे की रक्षा'
    },
    {
      name: 'Advocate Ankit Sharma',
      designation: 'Motor & Accident Law Specialist',
      designation_hi: 'मोटर और दुर्घटना कानून विशेषज्ञ',
      court: 'District Bar Association, Aligarh',
      court_hi: 'जिला बार एसोसिएशन, अलीगढ़',
      image: 'https://customer-assets.emergentagent.com/job_legal-portfolio-12/artifacts/p74dzqzn_IMG-20251028-WA0073.jpg',
      specialization: 'Motor Accident Claims, Insurance Cases, Personal Injury',
      specialization_hi: 'मोटर दुर्घटना दावे, बीमा मामले, व्यक्तिगत चोट'
    },
    {
      name: 'Advocate Tihendra Singh Bharti (Raj)',
      designation: 'Criminal Law Specialist',
      designation_hi: 'आपराधिक कानून विशेषज्ञ',
      court: 'District Bar Association, Aligarh',
      court_hi: 'जिला बार एसोसिएशन, अलीगढ़',
      image: 'https://customer-assets.emergentagent.com/job_legal-portfolio-12/artifacts/6c30ypdu_IMG-20240712-WA0007%20%281%29.jpg',
      specialization: 'Criminal Cases, Bail Matters, Trial Defense',
      specialization_hi: 'आपराधिक मामले, जमानत मामले, मुकदमे की रक्षा'
    }
  ];

  const isHindi = t.nav_home === 'मुख्य पृष्ठ';

  return (
    <section id="team" className="py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-2 text-gray-900" style={{ fontFamily: 'Crimson Text, serif' }}>
            {t.team_title || 'Our Associates'}
          </h2>
          <p className="text-center text-gray-600 mb-8 text-sm">
            {t.team_subtitle || 'Experienced legal professionals dedicated to serving justice'}
          </p>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {teamMembers.map((member, idx) => (
              <Card key={idx} className="overflow-hidden hover:shadow-lg transition-shadow">
                <div className="aspect-square overflow-hidden bg-gray-100">
                  <img 
                    src={member.image} 
                    alt={member.name} 
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <CardContent className="p-3">
                  <h3 className="text-sm font-bold mb-1 text-gray-900 leading-tight">{member.name}</h3>
                  <p className="text-amber-600 font-medium mb-1 text-xs">
                    {isHindi ? member.designation_hi : member.designation}
                  </p>
                  <p className="text-blue-900 text-xs flex items-start">
                    <Scale className="h-3 w-3 mr-1 mt-0.5 flex-shrink-0" />
                    <span className="leading-tight">{isHindi ? member.court_hi : member.court}</span>
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
